import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=7f0cd121&scoped=true&"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementModal.vue?vue&type=style&index=0&id=7f0cd121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0cd121",
  null
  
)

export default component.exports